import React from 'react';

const GradientProgressBar = ({ 
  progress, 
  height = 24, 
  showValue = true, 
  showEndLabels = true,
  className = "" 
}) => {
  // Ensure progress is between 0 and 100
  const clampedProgress = Math.max(0, Math.min(100, progress));
  
  return (
    <div className={`relative ${className}`}>
      {/* Main gradient progress bar */}
      <div 
        className="w-full rounded-full overflow-hidden shadow-sm" 
        style={{ height: `${height}px` }}
      >
        {/* Thermometer-like gradient from red through yellow to green */}
        <div 
          className="w-full h-full"
          style={{
            background: 'linear-gradient(to right, #dc2626 0%, #ef4444 15%, #f59e0b 35%, #eab308 50%, #84cc16 65%, #22c55e 80%, #16a34a 100%)'
          }}
        >
          {/* Progress overlay - creates the "unfilled" effect */}
          <div 
            className="h-full bg-white bg-opacity-50 transition-all duration-500 ease-in-out"
            style={{ 
              width: `${100 - clampedProgress}%`, 
              marginLeft: `${clampedProgress}%` 
            }}
          />
        </div>
      </div>
      
      {/* Arrow indicator */}
      <div 
        className="absolute top-0 transition-all duration-500 ease-in-out z-10"
        style={{ 
          left: `${clampedProgress}%`, 
          transform: 'translateX(-50%)'
        }}
      >
        {/* Progress value directly above the triangular arrow */}
        {showValue && (
          <div 
            className="absolute bg-slate-800 text-white text-xs px-2 py-1 rounded whitespace-nowrap font-semibold"
            style={{
              left: '50%',
              transform: 'translateX(-50%)',
              top: '-35px'
            }}
          >
            {Math.round(clampedProgress)}%
          </div>
        )}
        
        {/* Triangular pointer pointing down to the bar */}
        <div 
          className="w-0 h-0 border-l-2 border-r-2 border-b-3 border-l-transparent border-r-transparent border-b-slate-800"
          style={{ 
            borderLeftWidth: '6px', 
            borderRightWidth: '6px', 
            borderBottomWidth: '10px',
            marginTop: '-10px'
          }}
        />
        
        {/* Vertical line connecting arrow to bar */}
        <div 
          className="w-0.5 bg-slate-800 mx-auto"
          style={{ height: `${height}px` }}
        />
      </div>
      
      {/* Scale markers */}
      {showEndLabels && (
        <div className="flex justify-between mt-2 text-xs text-slate-500">
          <span>0%</span>
          <span className="text-red-600">Low</span>
          <span className="text-yellow-600">Medium</span>
          <span className="text-green-600">High</span>
          <span>100%</span>
        </div>
      )}
    </div>
  );
};

export default GradientProgressBar;